/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountState } from '../models/AccountState';
import { AccountVersion } from '../models/AccountVersion';
import { SourceAccountCloudAttributes } from '../models/SourceAccountCloudAttributes';

export class SourceAccount {
  /**
  * Eon-assigned source account ID.
  */
  'id': string;
  /**
  * Cloud-provider-assigned account ID.
  */
  'providerAccountId': string;
  /**
  * Account display name in Eon.
  */
  'name': string;
  /**
  * Display name inherited from the cloud provider.
  */
  'providerAccountName'?: string;
  'status': AccountState;
  'version'?: AccountVersion;
  /**
  * Date and time the account was connected to Eon.
  */
  'connectedTime'?: Date;
  'sourceAccountAttributes': SourceAccountCloudAttributes;
  /**
  * Whether job metrics are enabled for the account
  */
  'isJobMetricsEnabled'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerAccountId",
      "baseName": "providerAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerAccountName",
      "baseName": "providerAccountName",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "AccountState",
      "format": ""
    },
    {
      "name": "version",
      "baseName": "version",
      "type": "AccountVersion",
      "format": ""
    },
    {
      "name": "connectedTime",
      "baseName": "connectedTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "sourceAccountAttributes",
      "baseName": "sourceAccountAttributes",
      "type": "SourceAccountCloudAttributes",
      "format": ""
    },
    {
      "name": "isJobMetricsEnabled",
      "baseName": "isJobMetricsEnabled",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SourceAccount.attributeTypeMap;
  }

  public constructor() {
  }
}



